import AdminPageTypes from '../views/AdminPageTypes';

const Permissions = {
    SYSTEM: { name: 'System', initialPage: AdminPageTypes.USUARIOS },
    CENTER: { name: 'Center', initialPage: AdminPageTypes.NUCLEOS },
    COURSE: { name: 'Course', initialPage: AdminPageTypes.CURSOS },
    COURSEWARE: { name: 'Courseware', initialPage: AdminPageTypes.APOSTILAS },
    EVENT: { name: 'Event', initialPage: AdminPageTypes.EVENTS },
    PARTICIPANT: { name: 'Participant', initialPage: AdminPageTypes.PARTICIPANTES },
    SUBSCRIPTION: { name: 'Subscription', initialPage: AdminPageTypes.CREDENCIAMENTO },
    IMPORT_PARTICIPANTS: { name: 'ImportParticipants', initialPage: AdminPageTypes.IMPORTACAO },
    IMPORT_PRODUCTS: { name: 'ImportProducts', initialPage: AdminPageTypes.IMPORTACAO_PRODUTOS },
    ATTENDANCE: { name: 'Attendance', initialPage: AdminPageTypes.PRESENCA },
    PRODUCT: { name: 'Product', initialPage: AdminPageTypes.PRODUTOS },
    STORE: { name: 'Store', initialPage: AdminPageTypes.VENDA },
    CHECKOUT: { name: 'Checkout', initialPage: AdminPageTypes.CAIXA },
    DELIVERY: { name: 'Delivery', initialPage: AdminPageTypes.EXPEDICAO },
    STORE_CHECKOUT: { name: 'StoreCheckout', initialPage: AdminPageTypes.VENDA_CAIXA },
    STORE_CHECKOUT_DELIVERY: { name: 'StoreCheckoutDelivery', initialPage: AdminPageTypes.VENDA_CAIXA_EXPEDICAO },
    CHECKOUT_DELIVERY: { name: 'CheckoutDelivery', initialPage: AdminPageTypes.CAIXA_EXPEDICAO },
    REPORT: { name: 'Report', initialPage: AdminPageTypes.RELATORIO_VENDAS_TOTAIS },
    LOTTERY: { name: 'Lottery', initialPage: AdminPageTypes.SORTEIO },
};

export default Permissions;



// WEBPACK FOOTER //
// src/domain/Permissions.js